var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"login-icon"}),_c('iframe',{staticClass:"login-iframe",attrs:{"src":_vm.BaseUrl,"frameborder":"0","scrolling":"no"},on:{"load":function($event){return _vm.unload($event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }